function isThemeColor(o) {
    return o && typeof o.id === 'string';
}
const EditorType = {
    ICodeEditor: 'vs.editor.ICodeEditor',
    IDiffEditor: 'vs.editor.IDiffEditor'
};
export { EditorType, isThemeColor };
